import { api } from "./api";
import {
  HandlersGroupResponse,
  HandlersGroupCreate,
  HandlersGroupUpdate,
  HandlersUserResponse,
} from "../generated/models";

export const groupsService = {
  // Get all groups the authenticated user is a member of
  getMyGroups: async (): Promise<HandlersGroupResponse[]> => {
    const response = await api.get<HandlersGroupResponse[]>("/groups");
    return response.data;
  },

  // Get a specific group by ID
  getGroup: async (groupId: string): Promise<HandlersGroupResponse> => {
    const response = await api.get<HandlersGroupResponse>(`/groups/${groupId}`);
    return response.data;
  },

  // Create a new group
  createGroup: async (
    groupData: HandlersGroupCreate
  ): Promise<HandlersGroupResponse> => {
    const response = await api.post<HandlersGroupResponse>(
      "/groups",
      groupData
    );
    return response.data;
  },

  // Update an existing group
  updateGroup: async (
    groupId: string,
    groupData: HandlersGroupUpdate
  ): Promise<HandlersGroupResponse> => {
    const response = await api.put<HandlersGroupResponse>(
      `/groups/${groupId}`,
      groupData
    );
    return response.data;
  },

  // Delete a group
  deleteGroup: async (groupId: string): Promise<void> => {
    await api.delete(`/groups/${groupId}`);
  },

  // Get members of a group
  getGroupMembers: async (groupId: string): Promise<HandlersUserResponse[]> => {
    const response = await api.get<HandlersUserResponse[]>(
      `/groups/${groupId}/members`
    );
    return response.data;
  },

  // Add members to a group
  addGroupMembers: async (
    groupId: string,
    userIds: string[]
  ): Promise<HandlersUserResponse[]> => {
    const response = await api.post<HandlersUserResponse[]>(
      `/groups/${groupId}/members`,
      { user_ids: userIds }
    );
    return response.data;
  },

  // Remove a member from a group
  removeGroupMember: async (groupId: string, userId: string): Promise<void> => {
    await api.delete(`/groups/${groupId}/members/${userId}`);
  },
};

export default groupsService;
